import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import UserProfileDetails from "../../../Components/AdministrativeSettings/UserProfileDetails";
import { AdminService } from "../../../Services/Admin.service";
import Toaster from "../../../Components/Toaster";
import ConfirmationModal from "../../../Components/ConfirmationModal";
import TokenService from "../../../Services/Token.service";
import Loader from "../../../Components/Loader";
import InviteSpecialDonorModal from "../SampleRequests/InviteSpecialDonorModal";
import { SampleRequestService } from "../../../Services/SampleRequest.Service";

function DonorProfile() {
    const location = useLocation();
    const [donorData, setDonorData] = useState(location.state?.donor);
    const [donorId, setDonorID] = useState(location.state?.id);
    // const [donorId, setDonorID] = useState(location.state?.donor.id);
    useEffect(() => {        
        // Retrieve state from sessionStorage
        const savedState = sessionStorage.getItem('donorprofile');
        if (savedState) {
            setDonorID(JSON.parse(savedState).id); 
            // Optionally clear the saved state to prevent reuse
            sessionStorage.removeItem('donorprofile');
        }
    }, []);
    useEffect(() => {
        let isMounted = true; // To track if the component is still mounted
        const fetchUserDetails = async () => {
            if (donorId) {
                try {
                    const userDetails = await AdminService.getUserDetails(donorId);
                    if (isMounted) {
                        setDonorData(userDetails.user);
                    }
                } catch (error) {
                    console.error("Failed to fetch user details:", error);
                }
            }
        };
        fetchUserDetails();
        return () => {
            isMounted = false; // Cleanup: prevent state updates if unmounted
        };
    }, [donorId]);
    
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('');

    const [showDeactivateModal, setShowDeactivateModal] = useState(false);

    const handleShowDeactivateModal = () => setShowDeactivateModal(true);
    const handleCloseDeactivateModal = () => setShowDeactivateModal(false);

    const confirmDeactivateUser = () => {
        handleChangeStatus(donorData, donorData.active);
        handleCloseDeactivateModal();
    };


    const [showSelectSpecificDonorModal, setShowSelectSpecificDonorModal] = useState(false);
    
    const handleShowSelectSpecificDonorModal = () => setShowSelectSpecificDonorModal(true);
    const handleCloseSelectSpecificDonorModal = () => setShowSelectSpecificDonorModal(false);

 
    useEffect(() => {
        console.log("donorData", donorData);
    }, []);
    const [loading, setLoading] = useState(false);

    const handleChangeStatus = async (donor, status) => {
        setLoading(true);
        const newStatus = donor.active ? 0 : 1;
        try {
            const response = await AdminService.changeUserStatus(donor.id, newStatus);

            if (response.success == true) {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('success');
                const userDetails = await AdminService.getUserDetails(donorData.id);

                setDonorData(userDetails.user);
                setLoading(false);

            }
            else {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('error');
                setLoading(false);

            }
        } catch (error) {
            setToastMessage("Failed to change user status");
            setShowToast(true);
            setToastVariant('error');
            console.error("Failed to change user status:", error);
            setLoading(false);

        }
    };
 
    const confirmSelectSpecificDonor = async (payload) => {
        setLoading(true);
        try {
            const result = await SampleRequestService.inviteSpecificDonor(payload);
            if (result.success == true) { 
                // setNavigateToAdmin(true);
                console.log("Requestor Notified sucessfully:", result);
                setLoading(false);
                setToastMessage(result.message);
                setShowToast(true);
                setToastVariant('success');
            }
            else {
                // Check if the result.message is an object
                let formattedMessage = '';
                if (typeof result.message === 'object' && result.message !== null) {
                    // Convert object to a readable string
                    formattedMessage = Object.keys(result.message)
                        .map((key) => `${key}: ${result.message[key].join(', ')}`)
                        .join(' | ');
                } else {
                    // Use result.message directly if it's not an object
                    formattedMessage = result.message || 'An error occurred.';
                }

                setLoading(false);
                setToastMessage(formattedMessage);
                // setToastMessage(result.message);
                setShowToast(true);
                setToastVariant('error');
            }
        } catch (error) { 
            console.error("Failed to notify requestor:", error);
            setLoading(false);
            setToastMessage(error.message);
            setShowToast(true);
            setToastVariant('error');
        }
    
    }; 

    const previousUrl = TokenService.getPrevLink();
    return (
        <>   
        <Loader loading={loading}/>

        <div className="el-middle-wrapper">
            <h2 className="el-title">Donor Profile</h2>
            <Link className="back-link" to={`${previousUrl}`}><i className='el-icon-back'></i> Donor Management</Link>
            {donorData && (
                <>
                    <UserProfileDetails userType="donor" userData={donorData} handleChangeStatus={handleShowDeactivateModal} handleShowInviteDonorModal={handleShowSelectSpecificDonorModal} /> 
                </>
            )}
        </div>
            {/* Deactivate Confirmation Modal */}
            <ConfirmationModal
                show={showDeactivateModal}
                onHide={handleCloseDeactivateModal}
                onConfirm={confirmDeactivateUser}
                title=""
                body={`Are you sure you want to ${donorData?.active ? 'deactivate' : 'activate'} user?`}
                type='deactivateactivate'
            />
              <InviteSpecialDonorModal
                show={showSelectSpecificDonorModal}
                onHide={handleCloseSelectSpecificDonorModal}
                onConfirm={confirmSelectSpecificDonor} 
                id={donorData?.id}  //sending donor Id
                // ismatched ={sampleRequestDetails?.request?.matched_sample}
                type={"donor"}
            />
            {/* Reusable Toaster */}
            <Toaster
                show={showToast}
                message={toastMessage}
                variant={toastVariant}
                onClose={() => setShowToast(false)}
            />
        </>
    );
}

export default DonorProfile